export default "__VITE_ASSET__i5c59aFh__"